/**
 * The reply reference as the client SENDS it (2026-09-15).
 *
 * The browser knows which message is being answered and, optimistically, who
 * wrote it and what it said — enough to paint the sender's own bubble at once.
 * The server re-derives sender and excerpt from the shared store and is the
 * only party that ever sets `verified`, so the wire copy is the bounded ref
 * with any `verified` claim stripped: a client can never assert a quote is
 * checked.
 */
import { normalizeReplyRef, type MessageReplyRef } from '../../types/messageReply';

export function replyRefForWire(ref: MessageReplyRef | null | undefined): MessageReplyRef | undefined {
  const normalized = normalizeReplyRef(ref);
  if (!normalized) return undefined;
  const { verified: _clientClaim, ...wire } = normalized;
  void _clientClaim;
  return wire;
}
